import { useEffect, useState, useCallback, useRef, useMemo } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabsComponent from "../tabswitches";
import Intake from "./Intake";
import api from "../../../../api/api";
import LineChart from "../../../../graphs/linegraphs/trendslinegraph";
import { Backdrop, CircularProgress } from "@mui/material";
import { BloodPressure, WeightIcon, PulseIcon, SaturationIcon } from "./svgs";
import { useSelector } from "react-redux";
import moment from "moment";
import { getPracticeId } from "../../../../config/practice";

const Vitals = ({ dataId ,vitalsinternav,setVitalsInternav,setFetchedData}) => {
  const [graphSwitch, setGraphSwitch] = useState({
    Systolic: true,
    Diastolic: true,
    Pulse: true,
    Weight: true,
    BMI: true,
    O2Saturation: true,
    
  }); // State for toggling between graph types
  const [subTabValue, setSubTabValue] = useState(0); // Sub-tab value for BP, Weight, etc.
  const [previousvitals, setPreviousVitals] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0); // State for main Intake/Trends tabs
  const [vitalsData, setVitalsData] = useState({}); // State to hold API response data
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [selectedMonth, setSelectedMonth] = useState("Yearly"); // State for month selection
  const initialTabDecided = useRef(false);
  const [pharmadetails, setPharmaDetails] = useState({});
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const [pain, setPain] = useState(0);
  const patientID = dataId.patientid;
  const userConfig = useSelector((state) => state.userconfig);
  const practiseid = getPracticeId();
  // external tab control from parent
  useEffect(() => {
    if (vitalsinternav === 0 || vitalsinternav === 1) {
      setSelectedTab(vitalsinternav);

      // reset back so it doesn't keep forcing
      setVitalsInternav(false);

      // since parent decided tab, don't run auto logic
      initialTabDecided.current = true;
    }
  }, [vitalsinternav, setVitalsInternav]);
  const fetchpharmacydata = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/rx/patient/${dataId.patientid}/department/${userConfig.config.departmentid}/pharmacy`,
      );
      if (response.status == 200) {
        setPharmaDetails(response.data || {});
      } else {
        setPharmaDetails({});
      }
    } catch (error) {
      console.log(error);
    }
  };
  //   const fetchpreviousvitals = useCallback(async () => {
  //     try {
  //       setIsLoading(true);
  //       const response = await api.post(
  //         `/v1/${practiseid}/vitals/patient/${patientID}/vitalscurrent`
  //       );

  //       if (response.status === 200) {
  //         setPreviousVitals(response?.data || []);
  // if (response?.data?.[0]?.pain_level !== undefined && response?.data?.[0]?.pain_level !== null) {
  //   const painValue = parseInt(response.data[0].pain_level, 10);
  //   if (!isNaN(painValue)) {
  //     setPain(painValue);
  //   }
  // }

  //       } else {
  //         setPreviousVitals([]);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }, [practiseid, patientID]);
  const fetchpreviousvitals = useCallback(async () => {
    try {
      setIsLoading(true);

      const response = await api.post(
        `/v1/${practiseid}/vitals/patient/${patientID}/vitalscurrent`,
      );

      const vitals = response?.data || [];
      setPreviousVitals(vitals);

      // 🔥 auto select tab ONLY once
      if (!initialTabDecided.current) {
        if (vitals.length > 0) {
          setSelectedTab(1); // Trends
        } else {
          setSelectedTab(0); // Intake
        }
        initialTabDecided.current = true;
      }

      // pain
      if (vitals?.[0]?.pain_level != null) {
        const painValue = parseInt(vitals[0].pain_level, 10);
        if (!isNaN(painValue)) setPain(painValue);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [practiseid, patientID]);

  const fetchVitalsData = useCallback(async () => {
    setIsLoading(true);
    try {
      const payload = {
        department_id: 1,
      };

      const response = await api.post(
        `/v1/${practiseid}/vitals/patient/${patientID}/athena/get`,
        payload,
      );

      if (response.status === 200) {
        setVitalsData(response.data);
      } else {
        setVitalsData([]);
      }
    } catch (error) {
      console.error(
        "Error fetching Vitals data:",
        error.response ? error.response.data : error,
      );
    } finally {
      setIsLoading(false);
    }
  }, [practiseid, patientID]);

  const toggleGraph = (type) => {
    console.log(type);
    setGraphSwitch((prevState) => ({
      ...prevState,
      [type]: !prevState[type],
    }));
  };

  // Build last 5 vitals rows from API object (parallel arrays: systolic, diastolic, pulse, weight, etc.)
  const lastFiveVitals = useMemo(() => {
    const d = vitalsData || {};
    const dateLabels =
      d.systolicdatelabel ||
      d.diastolicdatelabel ||
      d.pulsedatelabel ||
      d.wtdatelabel ||
      d.O2Satdatelabel ||
      [];
    if (!Array.isArray(dateLabels) || dateLabels.length === 0) return [];

    const systolic = d.systolic || [];
    const systolicDates = d.systolicdatelabel || [];
    const diastolic = d.diastolic || [];
    const diastolicDates = d.diastolicdatelabel || [];
    const pulse = d.pulse || [];
    const pulseDates = d.pulsedatelabel || [];
    const weight = d.weight || [];
    const weightDates = d.wtdatelabel || [];
    const o2Sat = d.O2Sat || [];
    const o2SatDates = d.O2Satdatelabel || [];

    const uniqueDates = [...new Set(dateLabels)];

    const parseDateLabel = (value) =>
      moment(value, ["MM-DD-YYYY HH:mm:ss", "MM-DD-YYYY"], true);
    const sortedDates = uniqueDates
      .slice()
      .sort(
        (a, b) =>
          parseDateLabel(b).valueOf() - parseDateLabel(a).valueOf(),
      )
      .slice(0, 5);

    // Day-prefix of a date label, e.g. "05-04-2026 06:49:42" -> "05-04-2026"
    const dayPart = (s) => (typeof s === "string" ? s.split(" ")[0] : "");

    // Find the most recent reading for `metric` on the same calendar day as `dateStr`.
    // O2 (and sometimes others) is recorded at a different timestamp than BP, so
    // exact-match indexOf misses it; this falls back to a same-day lookup.
    const findIdxForDay = (dates, dateStr) => {
      const exact = dates.indexOf(dateStr);
      if (exact >= 0) return exact;
      const day = dayPart(dateStr);
      if (!day) return -1;
      let best = -1;
      let bestTs = -Infinity;
      for (let i = 0; i < dates.length; i++) {
        if (dayPart(dates[i]) === day) {
          const ts = parseDateLabel(dates[i]).valueOf();
          if (ts > bestTs) {
            bestTs = ts;
            best = i;
          }
        }
      }
      return best;
    };

    return sortedDates.map((dateStr) => {
      const parsed = parseDateLabel(dateStr);
      const sysIdx = findIdxForDay(systolicDates, dateStr);
      const diaIdx = findIdxForDay(diastolicDates, dateStr);
      const pulseIdx = findIdxForDay(pulseDates, dateStr);
      const wtIdx = findIdxForDay(weightDates, dateStr);
      const o2Idx = findIdxForDay(o2SatDates, dateStr);
      const bp =
        sysIdx >= 0 && diaIdx >= 0
          ? `${systolic[sysIdx] || "--"}/${diastolic[diaIdx] || "--"}`
          : "--";
      const o2 =
        o2Idx >= 0 && o2Sat[o2Idx] != null && o2Sat[o2Idx] !== ""
          ? `${o2Sat[o2Idx]}%`
          : "--";
      return {
        dateLabel: dateStr,
        date: parsed.isValid()
          ? parsed.format("MMM D, YYYY")
          : dateStr,
        time:
          parsed.isValid() && dateStr.includes(" ")
            ? parsed.format("HH:mm:ss")
            : "--",
        bp,
        pulse: pulseIdx >= 0 ? pulse[pulseIdx] : "--",
        weight: wtIdx >= 0 ? String(weight[wtIdx]) : "--",
        o2,
      };
    });
  }, [vitalsData]);

  // run once on mount
  useEffect(() => {
    fetchpreviousvitals();
  }, [fetchpreviousvitals]);

  // when user manually goes to trends
  useEffect(() => {
    if (selectedTab === 1) {
      fetchVitalsData();
    }
  }, [selectedTab, fetchVitalsData]);
  useEffect(() => {
    fetchpharmacydata();
  }, []);

  // Handling sub-tab change (BP, Weight, etc.)
  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue);
  };

  return (
    <div className="flex flex-col h-full min-h-0 overflow-y-auto always-visible-scrollbar">
      <div className="flex flex-col border w-[98%] p-3 pr-6 pl-6 mb-4 border-[#DAE3F8] bg-[white] rounded-xl ">
        {/* Main Tabs for Intake and Trends */}
        <div className="flex justify-between w-full items-center">
          <div className="my-2">
            <TabsComponent
              tabs={[{ label: "Intake" }, { label: "Trends" }]}
              selectedTab={selectedTab}
              onSelectTab={setSelectedTab}
            />
          </div>

          {/* Pain Slider */}
          {/* Pain Slider for Intake Tab */}
          {selectedTab === 0 && (
            <div className="flex gap-4">
              <div className="flex flex-col items-start mb-2 w-40">
                <span className="text-sm text-gray-600 mb-1">Pain</span>
                <div className="relative w-full">
                  {/* Range Slider */}
                  <input
                    type="range"
                    min={0}
                    max={10}
                    value={pain}
                    onChange={(e) => setPain(parseInt(e.target.value))}
                    className="range-slider w-full h-1 rounded-lg appearance-none cursor-pointer"
                    style={{
                      background: `linear-gradient(
          to right, 
          #E17954 ${(pain / 10) * 100}%, 
          rgba(225,121,84,0.5) ${(pain / 10) * 100}%
        )`,
                    }}
                  />

                  {/* Tooltip below slider */}
                  <span
                    className="absolute top-6 px-2 py-0.5 text-[11px] text-white rounded-md"
                    style={{
                      backgroundColor: "#E17954",
                      left: `${(pain / 10) * 100}%`,
                      transform: "translateX(-50%)",
                    }}
                  >
                    {pain}
                    <span
                      className="absolute left-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4"
                      style={{
                        borderLeftColor: "transparent",
                        borderRightColor: "transparent",
                        borderBottomColor: "#E17954",
                        top: "-4px",
                        transform: "translateX(-50%)",
                      }}
                    ></span>
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Month Selection Dropdown for Trends Tab */}
          {selectedTab === 1 && (
            <div className="flex flex-col items-start w-28">
              {/* <span className="text-sm text-gray-600 mb-1">Time Period</span> */}
              <div className="relative w-full">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="appearance-none bg-white border-[1px] border-[#DAE3F8] rounded-lg px-3 py-2 pr-8 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#E17954] focus:border-transparent cursor-pointer w-full"
                >
                  {" "}
                  <option value="Yearly">Yearly</option>
                  {/* <option value="All">All</option> */}
                  {/* <option value="Daily">Daily</option> */}
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="3 Months">3 Months</option>
                  {/* <option value="6 Months">6 Months</option> */}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-[#3788E5]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Intake Tab Content */}
        {selectedTab === 0 && (
          <div className="w-full">
            <Intake
              pharmadetails={pharmadetails}
              pain={pain}
              data={dataId}
              previousdata={
                Array.isArray(previousvitals) && previousvitals.length > 0
                  ? previousvitals[0]
                  : undefined
              }
              fetchpreviousvitals={fetchpreviousvitals}
              setFetchedData={setFetchedData}
            />
          </div>
        )}

        {/* Trends Tab Content */}
        {selectedTab === 1 && (
          <div className="mt-2">
            {/* Sub-Tabs under Trends */}
            <Tabs
              value={subTabValue}
              onChange={handleSubTabChange}
              style={{
                background: "transparent",
                border: "1px solid #DAE3F8",
                borderRadius: "15px",
                display: "flex",
              }}
              variant="fullWidth"
              indicatorColor="none"
            >
              {/* BP */}
              <Tab
                label={
                  <div className="flex items-center gap-2">
                    {BloodPressure}
                    <span>BP</span>
                  </div>
                }
                sx={{
                  backgroundColor:
                    subTabValue === 0 ? "#E17954" : "transparent",
                  color: subTabValue === 0 ? "#fff" : "#000",
                  flexGrow: 1,
                  borderRadius: subTabValue === 0 ? "12px" : "0px",
                  paddingX: "1px",
                  paddingY: "6px",
                  fontSize: "14px",
                  fontWeight: "medium",
                  minHeight: "32px",
                  "&.Mui-selected": {
                    color: "#fff",
                  },
                  margin: "5px",
                  textTransform: "none",
                }}
              />
              {/* PULSE */}
              {/* PULSE */}
              <Tab
                label={
                  <div className="flex items-center gap-2">
                    {PulseIcon}
                    <span>PULSE</span>
                  </div>
                }
                sx={{
                  backgroundColor:
                    subTabValue === 1 ? "#E17954" : "transparent",
                  color: subTabValue === 1 ? "#fff" : "#000",
                  flexGrow: 1,
                  borderRadius: subTabValue === 1 ? "12px" : "0px",
                  paddingX: "1px",
                  paddingY: "6px",
                  fontSize: "14px",
                  minHeight: "32px",
                  "&.Mui-selected": { color: "#fff" },
                  margin: "5px",
                  textTransform: "none",
                }}
              />

              {/* WEIGHT */}
              {/* WEIGHT */}
              <Tab
                label={
                  <div className="flex items-center gap-2">
                    {WeightIcon}
                    <span>WEIGHT</span>
                  </div>
                }
                sx={{
                  backgroundColor:
                    subTabValue === 2 ? "#E17954" : "transparent",
                  color: subTabValue === 2 ? "#fff" : "#000",
                  flexGrow: 1,
                  borderRadius: subTabValue === 2 ? "12px" : "0px",
                  paddingX: "1px",
                  paddingY: "6px",
                  fontSize: "14px",
                  minHeight: "32px",
                  "&.Mui-selected": { color: "#fff" },
                  margin: "5px",
                  textTransform: "none",
                }}
              />

              {/* O2 SATURATION */}
              <Tab
                label={
                  <div className="flex items-center gap-2">
                    {SaturationIcon}
                    <span>O2 SATURATION</span>
                  </div>
                }
                sx={{
                  backgroundColor:
                    subTabValue === 3 ? "#E17954" : "transparent",
                  color: subTabValue === 3 ? "#fff" : "#000",
                  flexGrow: 1,
                  borderRadius: subTabValue === 3 ? "12px" : "0px",
                  paddingX: "1px",
                  paddingY: "6px",
                  fontSize: "14px",
                  fontWeight: "medium",
                  minHeight: "32px",
                  "&.Mui-selected": {
                    color: "#fff",
                  },
                  margin: "5px",
                  textTransform: "none",
                }}
              />
            </Tabs>

            {/* Chart Content */}
            <div
              className="mt-2 w-full"
              style={{ height: "270px", width: "100%", display: "flex" }}
            >
              <LineChart
                resdata={vitalsData}
                graphSwitch={graphSwitch}
                selectedTab={subTabValue}
                selectedMonth={selectedMonth}
              />
            </div>

            {subTabValue === 0 && (
              <div className="flex justify-around items-center mt-5">
                <div className="flex gap-5">
                  {/* Systolic */}
                  <div
                    onClick={() => toggleGraph("Systolic")}
                    className={`text-center font-normal text-base leading-5 cursor-pointer relative ${
                      graphSwitch.Systolic ? "text-[#E17954]" : "text-gray-700"
                    }`}
                  >
                    Systolic
                    {graphSwitch.Systolic && (
                      <div className="absolute bottom-[-4px] left-0 right-0 h-[3px] rounded-[2px] bg-[#E17954]" />
                    )}
                  </div>

                  {/* Diastolic */}
                  <div
                    onClick={() => toggleGraph("Diastolic")}
                    className={`text-center font-normal text-base leading-5 cursor-pointer relative ${
                      graphSwitch.Diastolic ? "text-[#1D2951]" : "text-gray-700"
                    }`}
                  >
                    Diastolic
                    {graphSwitch.Diastolic && (
                      <div className="absolute bottom-[-4px] left-0 right-0 h-[3px] rounded-[2px] bg-[#1D2951]" />
                    )}
                  </div>
                </div>
              </div>
            )}

            {subTabValue === 2 && (
              <div className="flex justify-around items-center mt-5">
                <div className="flex gap-5">
                  {/* Weight */}
                  <div
                    onClick={() => toggleGraph("Weight")}
                    className={`text-center font-normal text-base leading-5 cursor-pointer relative ${
                      graphSwitch.Weight ? "text-[#E17954]" : "text-gray-700"
                    }`}
                  >
                    Weight
                    {graphSwitch.Weight && (
                      <div className="absolute bottom-[-4px] left-0 right-0 h-[3px] rounded-[2px] bg-[#E17954]" />
                    )}
                  </div>

                  {/* BMI */}
                  <div
                    onClick={() => toggleGraph("BMI")}
                    className={`text-center font-normal text-base leading-5 cursor-pointer relative ${
                      graphSwitch.BMI ? "text-[#1D2951]" : "text-gray-700"
                    }`}
                  >
                    BMI
                    {graphSwitch.BMI && (
                      <div className="absolute bottom-[-4px] left-0 right-0 h-[3px] rounded-[2px] bg-[#1D2951]" />
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Pulse Toggle */}
            {subTabValue === 1 && (
              <div
                onClick={() => toggleGraph("Pulse")}
                className="text-center font-normal text-base leading-5 cursor-pointer mt-5"
              >
                Pulse
              </div>
            )}
            {subTabValue === 3 && (
              <div
                onClick={() => toggleGraph("O2Saturation")}
                className="text-center font-normal text-base leading-5 mt-5 cursor-pointer"
              >
                O2 Saturation
              </div>
            )}
          </div>
        )}
        <Backdrop
          sx={{
            color: "secondary.main", // Sets the CircularProgress color to secondary
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
      </div>

      {/* Trends Tab Content */}
      {selectedTab === 1 && (
        <div className="w-[98%] mb-16">
          <div className="mt-2">
            <div
              className={`flex items-center justify-between bg-white  
    px-4 py-3 cursor-pointer shadow-sm
    ${isHistoryOpen ? "border-r-[1px] border-l-[1px] border-b-[1px] rounded-t-xl" : "border border-[#DAE3F8] rounded-xl"}
  `}
              onClick={() => setIsHistoryOpen((prev) => !prev)}
            >
              <span className="text-sm font-semibold text-[#1D2951]">
                All Readings History
              </span>
              <svg
                className={`w-4 h-4 text-[#1D2951] transform transition-transform duration-200 ${
                  isHistoryOpen ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>

            {isHistoryOpen && (
              <div className="bg-white border-r-[1px] border-l-[1px] border-b-[1px] border-t-0 border-[#DAE3F8] rounded-b-xl shadow-sm">
                <div className="max-h-72 overflow-y-scroll always-visible-scrollbar">
                  <table className="w-full text-xs">
                    <thead className="bg-[#F9FAFB] text-[12px] font-inter text-[#6A7282]">
                      <tr>
                        <th className="px-4 py-2 text-left font-semibold">
                          Date
                        </th>
                        <th className="px-4 py-2 text-left font-semibold">
                          Time
                        </th>
                        <th className="px-4 py-2 text-left font-semibold">
                          BP
                        </th>
                        <th className="px-4 py-2 text-left font-semibold">
                          Pulse
                        </th>
                        <th className="px-4 py-2 text-left font-semibold">
                          Weight
                        </th>
                        <th className="px-4 py-2 text-left font-semibold">
                          O2 Saturation
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-left ">
                      {lastFiveVitals.length > 0 ? (
                        lastFiveVitals.map((item, index) => (
                          <tr
                            key={`${item.dateLabel}-${index}`}
                            className="border-t border-[#EEF2FF] last:border-b"
                          >
                            <td className="text-[14px] font-inter text-[#1D2951] px-4 py-3 whitespace-nowrap">
                              {item.date}
                            </td>
                            <td className="text-[14px] font-inter text-[#1D2951] px-4 py-3 whitespace-nowrap">
                              {item.time}
                            </td>
                            <td className="text-[14px] font-inter text-[#1D2951] px-4 py-3 font-medium">
                              {item.bp}
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex flex-col leading-tight">
                                <span className="text-[14px] font-inter font-medium text-[#1D2951]">
                                  {item.pulse}
                                </span>
                                <span className="text-[12px] font-inter text-[#99A1AF]">
                                  bpm
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <span className="text-[14px] font-inter font-medium text-[#1D2951]]">
                                {item.weight}
                              </span>
                              <span className="ml-0.5 text-[12px] font-inter text-[#99A1AF]">
                                lbs
                              </span>
                            </td>
                            <td className="text-[14px] font-inter font-medium text-[#1D2951] px-4 py-3">
                              {item.o2}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={6}
                            className="px-4 py-3 text-center text-gray-400"
                          >
                            No vitals history available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Vitals;
